<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/setup/fee-master" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3 v-if="viewService && viewService.feeMasterData && viewService.feeMasterData.feeCode">
              <td>{{ viewService.feeMasterData.feeCode }}</td>
            </h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="EditFeemaster(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deletefeemasterPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table v-if="viewService && viewService.feeMasterData" class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.FeeMasterCode") }}</b>
                    </td>
                    <td>{{ viewService.feeMasterData.feeCode }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.FeeMasterDescription") }}</b>
                    </td>
                    <td>{{ viewService.feeMasterData.feeDescription }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.FeeMasterTransactionType") }}</b>
                    </td>
                    <td>{{ viewService.feeMasterData.transactionType }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ChargeCode") }}</b>
                    </td>
                    <td>{{ viewService.feeMasterData.chargeCode }}</td>
                  </tr>

                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Amount") }} </b>
                    </td>
                    <td>
                      {{ viewService.feeMasterData.defaultFeeAmount }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.RegionName") }} </b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.Amount") }} </b>
                    </td>
                  </tr>
                  <tr
                    v-for="(
                      Services, index
                    ) in viewService.feeMasterRegionPricesDatas"
                    :key="index"
                  >
                    <td>{{ getRegionName(Services.regionId) }}</td>
                    <td>{{ Services.amount }}</td>
                  </tr>

                  <tr></tr>
                </table>
              </div>
            </div>
          </div>

          <!-- <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full mt-6 table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("Region Name") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("Amount") }}</b>
                    </td>
                  </tr>

                  <tr
                    v-for="(
                      Services, index
                    ) in viewService.feeMasterRegionPricesDatas"
                    :key="index"
                  >
                    <td>{{ Services.regionId }}</td>
                    <td>{{ Services.amount }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div> -->
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deletefeemasterPopup"
      :title="$t('setup.label.FeeMaster')"
      @deletePressed="deletefeemaster()"
      @cancelPressed="deletefeemasterPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      id: "",
      viewService: {},
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      deletefeemasterPopup: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      Services: (state) => state.feeMaster.FeeMaster,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    getRegionName(regionId) {
      const region = this.Services.regionDatas.find((r) => r.id === regionId);
      return region ? region.regionName : "Unknown Region";
    },
    EditFeemaster(id) {
      this.$router.push({ name: "Edit Fee Master", params: { id: id } });
    },

    async getfeemaster() {
      try {
        await this.$store.dispatch("feeMaster/setfeemaster", this.id);
        this.viewService = this.Services;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deletefeemaster() {
      this.deletefeemasterPopup = false;
      await this.$store.dispatch("feeMaster/deletefeemasterAction", this.id);
      this.$router.push(`/setup/fee-master`);
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getfeemaster();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
